import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index.js'
import ElementUI from 'element-ui'
import AMap from 'vue-amap';
Vue.use(AMap);
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '4365df5e295713cc4d8dcbdcef934a0f',
  // 插件集合 （插件按需引入）
  // plugin: ['AMap.Geolocation']
  plugin: ['AMap.Geocoder', 'AMap.Geolocation', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
});
Vue.use(ElementUI, {
  size: 'mini'
})
import('element-ui/lib/theme-chalk/index.css')

const $cookies = require('vue-cookies')
Vue.use($cookies);

// import './components/iconSvg' // iconSvg
import '@/icons'; //icon

// i18n国际化
import i18n from "@/lang";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n, // 便于可以直接在组件中通过this.$i18n使用，也可以按需引用
  render: h => h(App)
}).$mount('#app')